import BaseEvent from './BaseEvent'
import { isString, isNumber, isArray } from 'util'

export default class BaseCollection extends BaseEvent {
    /**
     * collections
     */
    constructor() {
        super()

        this._index = 0
        this._collection = []
    }

    get length() {
        return this._collection.length
    }

    // 迭代器
    [Symbol.iterator]() {
        return this
    }

    // 迭代器（必须的方法）
    next() {
        if (this._index < this.length) {
            // get value
            const value = this._collection[this._index]
            // add index
            this._index++
            // reture value
            return { done: false, value: value }
        } else {
            // reset index
            this._index = 0
            return { done: true, value: undefined }
        }
    }

    // 遍历方法
    forEach(handler) {
        this._collection.forEach(handler)
    }

    /**
     * 添加
     * @param {*} v
     */
    add(v) {
        this._collection.push(v)
        this.fire('add', v)
    }

    /**
     * 删除
     * @param {*} v
     */
    remove(v) {
        let markers
        const i = this._collection.indexOf(v)

        if (i !== -1) {
            this._collection.splice(this._collection.indexOf(v), 1)
            markers = [v]
        } else {
            markers = this.query(v)
            for (let i = 0; i < markers.length; i++) {
                const marker = markers[i]
                this._collection.splice(this._collection.indexOf(marker), 1)
            }
        }
        this.fire('remove', markers)
        return markers
    }

    /**
     * 查询
     * @param {*} v
     * @returns {Array}
     */
    query(v) {
        if (isNumber(v)) {
            if (this._collection[v]) {
                return [this._collection[v]]
            } else {
                return []
            }
        } else if (isArray(v)) {
            let key = 'id',
                value,
                operator = '=='
            if (v.length == 1) {
                value = v[0]
            } else if (v.length == 2) {
                key = v[0]
                value = v[1]
            } else {
                key = v[0]
                value = v[1]
                operator = v[2]
            }
            return this._collection.filter(m => {
                if (isString(value)) {
                    return eval(`'${m[key]}' ${operator} '${value}'`)
                }
                return eval(`${m[key]} ${operator} ${value}`)
            })
        }
        return []
    }

    /**
     * 查找索引
     * @param {*} v
     */
    findIndex(v) {
        return this._collection.indexOf(v)
    }

    /**
     * 添加多个
     * @param  {...any} rest
     */
    addAll(...rest) {
        this._collection.push(...rest)
        this.fire('addAll', rest)
    }

    /**
     * 清空
     */
    clear() {
        this._collection = []
        this.fire('clear')
    }
}
